import { addBreadcrumb } from "../redux/action-creaters/breadcrumbs";
import pagesWrapper from "./pagesWrapper";
import { Api } from "../api";
import { setDescription, setTitle } from "../redux/action-creaters/meta";

export const PAGE_SIZE = 28;

export default async function newsCatalogWrapper(
  Redis,
  store,
  query,
  req,
  code,
  title,
) {
  const currentPage = +query.PAGEN_2 || 1;
  const sections = await Api.news.fetchSections(Redis, Boolean(query.reset));
  const section = sections.find((section) => section.CODE === code);
  const host = req.headers.host.split(".")[0];
  // const host = 'spb';
  const news = (
    await Api.news.getNewsAll(Redis, section.ID, Boolean(query.reset))
  )?.filter((news) => {
    if (
      !news.DOMAINS ||
      news.DOMAINS.length === 0 ||
      news.DOMAINS.includes(host)
    ) {
      return true;
    }
    return false;
  });

  store.dispatch(addBreadcrumb({ link: `/${code}/`, name: title }));
  store.dispatch(setTitle(title));
  store.dispatch(setDescription(title));

  return await pagesWrapper(
    {
      code,
      title,
      section,
      sections,
      news: news.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE),
      pageSize: PAGE_SIZE,
      size: news.length,
      currentPage,
    },
    store,
    Redis,
    {
      query,
      req,
    },
    "/nashe-portfolio/",
  );
}
